// The workspace @spotted-zebra-uk/ui-components package is served
// un-prebundled from dist/esm in Vite dev. Some bundled deps (react-tooltip's
// dropdown-menu path, @carbon/*) read process.env at runtime, so give dev a
// real global. This client has no vite `define` block, so this polyfill is the
// whole process.env fix (dev and prod). Must be the FIRST import of the entry
// so it evaluates before the ui-components module graph.
globalThis.process ??= { env: {} } as NodeJS.Process;

export {};
